import ProductGrid from './ProductGrid';

export default ProductGrid;
